import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from '../../../components/iconify';
import Services from 'src/services/Services';
import { useDispatch } from 'react-redux';
import { updateCustomerValue } from 'src/store/customer';

export default function LoginForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [currentView, setCurrentView] = useState('login');

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [isChecked, setChecked] = useState(false);
  const [userId, setUserId] = useState(null);
  const [newPasswordVal, setNewPasswordVal] = useState('');
  const [confirmPasswordVal, setConfirmPasswordVal] = useState('');

  const [modal, setModal] = useState(false);
  const [html, setHtml] = useState('');
  const [tempUserData, setTempUserData] = useState(null);

  const handleAuthSuccess = (responseResult) => {
    localStorage.setItem('expired', JSON.stringify(responseResult.expired));
    localStorage.removeItem('firstLoginResetDone');

    if (
      responseResult.type === 'porter' &&
      responseResult.frontAuth?.length === 1 &&
      responseResult.frontAuth[0] === 'operations'
    ) {
      toast.error('Panele giriş izniniz bulunmamaktadır.');
      return;
    }

    if (responseResult?.type !== 'superadmin')
      localStorage.setItem('user', JSON.stringify(responseResult));

    if (responseResult?.token)
      localStorage.setItem('tokenForService', responseResult.token);

    if (responseResult?.accountCategory === 'store') {
      localStorage.setItem(
        'branchID',
        responseResult?.authLocations?.branch[0]?.branchID
      );
      localStorage.setItem(
        'mallID',
        responseResult?.authLocations?.branch[0]?.mallID
      );
      localStorage.setItem(
        'easypointID',
        responseResult?.authLocations?.branch[0]?.mall[0]?.points?.malkabul?.id
      );
      dispatch(
        updateCustomerValue({
          id: responseResult?.authLocations?.branch[0]?.branchID,
          title: responseResult?.authLocations?.branch[0]?.title,
        })
      );
      localStorage.setItem(
        'mallsTransportationTools',
        JSON.stringify(responseResult?.mallsTransportationTools)
      );
    } else if (responseResult?.accountCategory === 'mall-logistics') {
      localStorage.setItem(
        'mallID',
        responseResult?.authLocations?.mall[0]?.id
      );
      dispatch(
        updateCustomerValue({
          id: responseResult?.authLocations?.mall[0]?.id,
          title: responseResult?.authLocations?.mall[0]?.title,
        })
      );
      localStorage.setItem(
        'easypointID',
        responseResult?.authLocations?.mall[0]?.points?.malkabul?.id
      );
      localStorage.setItem(
        'mallsTransportationTools',
        JSON.stringify(responseResult?.mallsTransportationTools)
      );
    } else if (responseResult?.type === 'superadmin') {
      Services.GetMallsForSuperadminLogin(responseResult.token).then((res) => {
        if (res.data.status) {
          const malls = res.data.result;
          const updatedData = {
            ...responseResult,
            authLocations: { ...responseResult.authLocations, mall: malls },
            accountCategory: 'mall-logistics',
          };
          localStorage.setItem(
            'mallID',
            updatedData?.authLocations?.mall[0]?.id
          );
          dispatch(
            updateCustomerValue({
              id: updatedData?.authLocations?.mall[0]?.id,
              title: updatedData?.authLocations?.mall[0]?.title,
            })
          );
          localStorage.setItem('user', JSON.stringify(updatedData));
          navigate(location.state?.from?.pathname || '/dashboard');
        } else {
          toast.error(res.data.message);
        }
      });
      return;
    } else if (responseResult?.accountCategory === 'company') {
      localStorage.setItem(
        'mallID',
        responseResult?.authLocations?.branch[0]?.mallID
      );
      localStorage.setItem(
        'branchID',
        responseResult?.authLocations?.branch[0]?.branchID
      );
      dispatch(
        updateCustomerValue({
          id: responseResult?.authLocations?.branch[0]?.mallID,
          title: responseResult?.authLocations?.branch[0]?.mall[0].title,
        })
      );
    } else {
      localStorage.setItem(
        'mallID',
        responseResult?.authLocations?.mall[0]?.id
      );
      dispatch(
        updateCustomerValue({
          id: responseResult?.authLocations?.mall[0]?.id,
          title: responseResult?.authLocations?.mall[0]?.title,
        })
      );
    }

    if (responseResult?.accountCategory === 'company') {
      navigate('/dashboard/finished-jobs');
    } else {
      navigate(location.state?.from?.pathname || '/dashboard');
    }
  };

  // --- LOGIN SUBMIT ---
  const handleLoginSubmit = (e) => {
    e.preventDefault();
    if (!loginEmail || !loginPassword) {
      toast.info('Lütfen tüm alanları doldurunuz.');
      return;
    }
    setLoading(true);

    Services.Login(loginEmail, loginPassword)
      .then((response) => {
        const data = response?.data?.result;
        if (response.data.status) {
          if (data?.token) localStorage.setItem('tokenForService', data.token);
          setUserId(data?.userID);

          // İLK GİRİŞ KONTROLÜ (Güncellendi)
          if (data?.isFirstLogin) {
            setTempUserData(data);
            setLoading(false);
            setCurrentView('first_login_update');
            return;
          }

          handleAuthSuccess(data);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      })
      .finally(() => {
        if (currentView === 'login') setLoading(false);
      });
  };

  const handleUpdatePassword = (e) => {
    e.preventDefault();
    if (newPasswordVal.length < 4) {
      toast.warning('Şifreniz en az dört karakterden oluşmalıdır.');
      return;
    }
    if (newPasswordVal !== confirmPasswordVal) {
      toast.error('Yeni şifreler eşleşmemektedir.');
      return;
    }

    setLoading(true);
    Services.EditPassword(newPasswordVal)
      .then((res) => {
        if (res.data.status) {
          toast.success('Şifreniz başarıyla güncellenmiştir.');

          if (tempUserData) handleAuthSuccess(tempUserData);
          else navigate('/dashboard');
        } else {
          toast.error('Şifre güncellenemedi: ' + (res.data.message || ''));
          setLoading(false);
        }
      })
      .catch((err) => {
        toast.error('Hata: ' + err.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    Services.GetAgreementWithoutToken('23986740293876492837').then(
      (response) => {
        setHtml(response.data.result.description);
      }
    );
  }, []);

  // --- RENDER ---

  // 1. İlk Giriş - Şifre Güncelleme Ekranı
  if (currentView === 'first_login_update') {
    return (
      <Stack spacing={3} sx={{ mt: 2 }}>
        <form onSubmit={handleUpdatePassword}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              name="newPassword"
              label="Yeni şifrenizi giriniz..."
              type="password"
              value={newPasswordVal}
              onChange={(e) => setNewPasswordVal(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              fullWidth
              name="confirmPassword"
              label="Yeni şifrenizi tekrar giriniz..."
              type="password"
              value={confirmPasswordVal}
              onChange={(e) => setConfirmPasswordVal(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />

            <LoadingButton
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              loading={loading}
              sx={{
                backgroundColor: '#3556cd',
                mt: 2,
                boxShadow: 'none',
                '&:hover': { backgroundColor: '#2642a4' },
              }}
            >
              Şifreyi Güncelle ve Giriş Yap
            </LoadingButton>
          </Stack>
        </form>
      </Stack>
    );
  }

  // 2. Standart Login Ekranı
  return (
    <>
      <form id="login-form" onSubmit={handleLoginSubmit}>
        <Stack spacing={3} sx={{ mt: 3 }}>
          <TextField
            required
            id="email"
            name="email"
            label="E-postanızı/Kullanıcı Adınızı Giriniz"
            value={loginEmail}
            onChange={(e) => setLoginEmail(e.target.value)}
            autoComplete="off"
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            required
            id="password"
            name="password"
            label="Şifrenizi girin"
            value={loginPassword}
            onChange={(e) => setLoginPassword(e.target.value)}
            type={showPassword ? 'text' : 'password'}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    <Iconify
                      icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ my: 2 }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              checked={isChecked}
              onChange={() => (isChecked ? setChecked(false) : setModal(true))}
              sx={{ padding: '0 8px 0 0' }}
            />
            <Typography
              variant="body2"
              sx={{
                textDecoration: 'underline',
                color: '#103996',
                cursor: 'pointer',
                fontWeight: 500,
              }}
              onClick={() => setModal(true)}
            >
              Aydınlatma Metni
            </Typography>
          </Box>

          {/* Şifremi Unuttum linki kaldırıldı */}
        </Stack>

        <LoadingButton
          disabled={loading || !isChecked}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={loading}
          sx={{
            backgroundColor: '#3556cd',
            boxShadow: 'none',
            '&:hover': { backgroundColor: '#2642a4' },
          }}
        >
          Giriş Yap
        </LoadingButton>

        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1.5}
          sx={{ mt: 2.5 }}
        >
          <Typography
            variant="body2"
            sx={{
              color: '#103996',
              cursor: 'pointer',
              fontWeight: 600,
              textDecoration: 'underline',
              textUnderlineOffset: '3px',
              '&:hover': { color: '#2642a4' },
            }}
            onClick={() => window.open('/form-without-login', '_blank')}
          >
            Hesap Oluşturun
          </Typography>

          <Typography variant="body2" sx={{ color: '#C4CDD5' }}>
            |
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: '#637381',
              cursor: 'pointer',
              fontWeight: 500,
              textDecoration: 'underline',
              textUnderlineOffset: '3px',
              '&:hover': { color: '#103996' },
            }}
            onClick={() => navigate('/forgot-password')}
          >
            Şifremi Unuttum
          </Typography>
        </Stack>
      </form>

      <Stack sx={{ mt: 5 }}>
        <Typography sx={{ color: '#676767', mb: 1, fontSize: '0.9rem' }}>
          Faturanızı Kolayca Ödeyin
        </Typography>
        <LoadingButton
          sx={{ borderColor: '#D8DDE1', color: '#103996', fontWeight: 500 }}
          fullWidth
          size="large"
          variant="outlined"
          onClick={() => window.open('/pay-bill', '_blank')}
        >
          Fatura Öde
        </LoadingButton>
      </Stack>

      <Dialog open={modal} onClose={() => setModal(false)}>
        <DialogTitle>Aydınlatma Metni</DialogTitle>
        <DialogContent>
          <DialogContentText dangerouslySetInnerHTML={{ __html: html }} />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: 'green',
              color: 'white',
              '&:hover': { backgroundColor: 'darkgreen' },
            }}
            onClick={() => {
              setChecked(true);
              setModal(false);
            }}
          >
            Okudum, Anladım, Onaylıyorum
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
